// Section placeholder — rendered for every tab until the real
// implementation lands. Each call site passes the name + tagline so the
// app shell can be navigated end-to-end without the sections existing.

export function Placeholder({ name, tagline }: { name: string; tagline: string }) {
  return (
    <div className="ph-section">
      <div>
        <h1 className="h-display">{name}</h1>
        <p className="ph-tagline">{tagline}</p>
        <p className="ph-note">section not ported yet</p>
      </div>
    </div>
  );
}
